import { withErrorParsing } from '../../dialect-cloud-api/data-service-errors';
export class DataServiceDappNotificationSubscriptions {
    constructor(api) {
        this.api = api;
    }
    async findAll() {
        const dtos = await withErrorParsing(this.api.findAll());
        return dtos.map((it) => ({
            ...it,
            subscriptions: it.subscriptions.map((it) => ({
                ...it,
                wallet: {
                    ...it.wallet,
                    address: it.wallet.publicKey,
                },
            })),
        }));
    }
}
//# sourceMappingURL=data-service-dapp-notification-subscriptions.js.map